import React, { useEffect, useRef, useState } from 'react';

/**
 * ÖLÇEKLİ KUTU — "her genişlikte yan yana" kuralının teknik karşılığı
 *
 * Selçuk'un kuralı: "solda biri sağda biri sabit olacak, mobil tablette de
 * ekran ne kadar küçülürse küçülsün sabit yap."
 *
 * SORUN: Dört animasyonun hepsi sabit tasarım genişliğine sahiptir
 * (Suspend AI 180px daire, Server 74px SVG, Radar paneli ~420px, CRM grafiği
 * 356px). 280px'lik bir ekranda sütun genişliği ~120px'e düşer; hiçbiri
 * sığmaz ve ya taşarlar ya da düzen alt alta kırılır.
 *
 * ÇÖZÜM: Düzeni kırmak yerine animasyonu ORANTILI KÜÇÜLTMEK. İçerik daima
 * kendi tasarım genişliğinde çizilir; kutu ölçülür ve `transform: scale()`
 * ile ölçeklenir. Böylece animasyonun kendi içindeki HİÇBİR değer (renk,
 * süre, keyframe, gölge, path) değişmez — sadece bakış mesafesi değişir.
 * Dış kutunun yüksekliği de aynı katsayıyla küçültülür ki altında boşluk
 * kalmasın ve sayfa akışı bozulmasın.
 *
 * `enBuyukOlcek` geniş ekranda gereksiz büyümeyi engeller.
 */
export default function OlcekliKutu({ tasarimGenisligi, enBuyukOlcek = 1, className = '', children }) {
  const disRef = useRef(null);
  const icRef = useRef(null);
  const [olcek, setOlcek] = useState(1);
  const [yukseklik, setYukseklik] = useState(0);

  useEffect(() => {
    const dis = disRef.current;
    const ic = icRef.current;
    if (!dis || !ic) return undefined;

    let sonOlcek = null;
    let sonYukseklik = null;

    const olc = () => {
      const genislik = dis.clientWidth;
      if (!genislik) return;
      const k = Math.min(enBuyukOlcek, genislik / tasarimGenisligi);
      const h = ic.offsetHeight * k;
      /* Aynı değeri tekrar yazmak ResizeObserver ile sonsuz döngü riski
         yaratır; bu yüzden yalnızca gerçekten değiştiğinde durum güncellenir. */
      if (sonOlcek === null || Math.abs(k - sonOlcek) > 0.0005) {
        sonOlcek = k;
        setOlcek(k);
      }
      if (sonYukseklik === null || Math.abs(h - sonYukseklik) > 0.5) {
        sonYukseklik = h;
        setYukseklik(h);
      }
    };

    olc();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(olc) : null;
    if (ro) {
      ro.observe(dis);
      ro.observe(ic);
    }
    window.addEventListener('resize', olc);
    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', olc);
    };
  }, [tasarimGenisligi, enBuyukOlcek]);

  return (
    <div ref={disRef} className={`wh-urun-olcek ${className}`} style={{ height: yukseklik || undefined }}>
      <div
        ref={icRef}
        className="wh-urun-olcek-ic"
        style={{ width: tasarimGenisligi, transform: `translateX(-50%) scale(${olcek})` }}
      >
        {children}
      </div>
    </div>
  );
}
